module.exports = __webpack_public_path__ + "img/c-2.74c01e1-en.19897862.png";